import React, { useEffect, useState } from "react";
import { SelectUi } from "../ui/SelectUi";
import { get_tiposdocumentospersona } from "../../actions";

export const TipoDocumentoSelect = ({ ...props }) => {
  const [tipodocumentos, setTipodocumentos] = useState([]);
  const OnLoadTipoDocumentos = async () => {
    const datos = await get_tiposdocumentospersona();
    setTipodocumentos(datos);
  };
  useEffect(() => {
    OnLoadTipoDocumentos();
  }, []);
  return <SelectUi data={tipodocumentos} {...props} />;
};
